import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactForm = () => {
  const [email, setEmail] = useState("");
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !query) {
      toast.error("Please fill in all fields!", { position: "top-right" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("http://localhost:5000/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, query }),
      });

      if (response.ok) {
        toast.success("Query submitted successfully!", { position: "top-right" });
        setEmail("");
        setQuery("");
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || "Failed to submit query. Please try again.", { position: "top-right" });
      }
    } catch (error) {
      toast.error("Something went wrong! Check your internet connection.", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white flex flex-col items-center justify-center p-8 relative overflow-hidden">
      {/* Background Gradient Effects */}
      <div className="absolute top-[-100px] left-[-100px] w-96 h-96 bg-blue-500 opacity-25 blur-3xl rounded-full"></div>
      <div className="absolute bottom-[-100px] right-[-100px] w-96 h-96 bg-purple-500 opacity-25 blur-3xl rounded-full"></div>

      {/* Contact Form */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="max-w-lg w-full bg-gray-900/50 backdrop-blur-lg p-8 rounded-xl shadow-lg"
      >
        <h2 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-blue-400 to-purple-400 text-transparent bg-clip-text text-center mb-6">
          Contact Us
        </h2>

        <form className="space-y-6" onSubmit={handleSubmit}>
          {/* Email Input */}
          <div className="space-y-2">
            <label htmlFor="email" className="block text-gray-300 font-medium">
              Company Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-gray-600 bg-transparent rounded-lg text-white focus:outline-none focus:border-blue-400"
            />
          </div>

          {/* Query Input */}
          <div className="space-y-2">
            <label htmlFor="query" className="block text-gray-300 font-medium">
              How Can We Help You?
            </label>
            <textarea
              name="query"
              id="query"
              rows={6}
              required
              placeholder="Enter your query"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="w-full px-4 py-3 border border-gray-600 bg-transparent rounded-lg text-white focus:outline-none focus:border-purple-400"
            ></textarea>
          </div>

          {/* Submit Button */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="w-full bg-blue-600 hover:bg-blue-700 transition-all text-white font-bold py-3 px-8 rounded-full shadow-lg text-lg flex justify-center items-center"
            type="submit"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </motion.button>
        </form>
      </motion.div>

      {/* Toastify Container */}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default ContactForm;
